import { orderLegSideEnum } from '@/constants/order'
import { calculateGcd } from './calculateGcd'
import { CallPut } from '@/enums/OrderTicket.enum'

export function calculateOrderPrevCloseValue(legs) {
  var legQuantities = []
  const prevClose = legs.reduce((acc, leg) => {
    const prevDayCloseValue = parseFloat(leg.previousDayCloseValue || 0)
    var absQty = Math.abs(leg.quantity)

    if (leg.legType == CallPut.equity) absQty = absQty / 100

    legQuantities.push(absQty)

    if (leg.side === orderLegSideEnum.BUY) {
      acc += prevDayCloseValue * absQty
    } else {
      acc -= prevDayCloseValue * absQty
    }
    return acc
  }, 0)

  var gcd = calculateGcd(legQuantities)
  if (!gcd) gcd = 1
  return (prevClose / gcd).toFixed(2)
}
